import { type ModalProps } from "@client/controls/Modal/component";
import { type StickSide } from "@client/hocs/stickable";
import { type LeftTop } from "@client/types";

export const MODAL_INVISIBLE_PROPS: ModalProps = {
  hasBackdrop: false,
  isAdminColor: false,
  isCentered: false,
  isDraggable: false,
  isLoading: false,
  isVisible: false,
  stickSide: null,
  onClose: () => undefined,
  children: () => <any>null
};

export const getInitialPosition = (toStickSide: StickSide | null, width: string | number): LeftTop | undefined => {
  const top = 16;
  switch (toStickSide) {
    case "left":
      return { left: 16, top };
    case "right":
      return { left: window.innerWidth - parseInt(width.toString()) - 16, top };
  }
};
